<script>
	import { state } from "../store";
	import { action } from "../api";

	setTimeout(() => {
		action("makeAdmin");
	}, 500);

	$: gameState = $state.game.state;
	$: round = $state.game.round;

	let editText = "";

	const nextRound = () => {
		action("nextRound");
	};

	const reset = () => {
		action("reset");
	};

	const editState = () => {
		action("editState", ...editText.split("=>").map((s) => s.trim()));
	}
</script>

<div class="container">
	<div class="hr">
		<hr />
	</div>
	<div>
		State: {gameState}
	</div>
	<div>
		Round: {round}
	</div>
	<div>
		<button on:click={nextRound}> Next Round </button>
	</div>
	<div>
		<button on:click={reset}> Reset Game</button>
	</div>
	<div>
		<input bind:value={editText} size="30" />
		<button on:click={editState}> Edit State</button>
	</div>
	<div>
		<pre>
			{JSON.stringify($state, null, 4)}
		</pre>
	</div>
</div>

<style>
	.container {
		display: flex;
		flex-direction: column;
		align-items: center;
		margin-top:  40px;
	}

	.container > div {
		margin-bottom: 5px;
	}

	.hr {
		width: 100%;
	}

	pre {
		width: 300px;
		text-align: left;
	}
</style>